import Button from '@zenbusiness/zui/Button';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import { styled } from '@zenbusiness/zui/styles';
import { Document } from 'react-pdf';

const DialogStyle = ({ theme }) => ({
  zIndex: theme.zIndex.modal,
  padding: 0
});

const DialogTitleStyle = ({ theme, webview }) => ({
  padding: webview ? '16px 4px 16px 4px' : '16px 4px 8px 4px',
  [theme.breakpoints.up('sm')]: {
    padding: '20px 16px'
  }
});

const ContainerStyle = () => ({
  margin: 'auto',
  maxWidth: '1200px'
});

const DialogContextStyle = ({ theme }) => ({
  '&.MuiDialogContent-root': {
    height: '100%',
    padding: 0,
    backgroundColor: theme.palette.background.grey.main
  }
});

const ButtonStyle = ({ theme }) => ({
  height: '36px',
  [theme.breakpoints.up('sm')]: {
    height: '40px'
  }
});

const DocumentStyle = ({ theme }) => ({
  padding: '24px 16px',
  [theme.breakpoints.up('md')]: {
    padding: '48px 0px'
  }
});

export const DialogStyled = styled(Dialog)(DialogStyle);
export const DialogTitleStyled = styled(DialogTitle)(DialogTitleStyle, {
  shouldForwardProp: (prop) => prop !== 'webview'
});
export const ContainerStyled = styled('div')(ContainerStyle);
export const DialogContentStyled = styled(DialogContent)(DialogContextStyle);
export const ButtonStyled = styled(Button)(ButtonStyle);
export const DocumentStyled = styled(Document)(DocumentStyle);
